export default "__VITE_ASSET__CAwia5Wg__"